// The External EMS values offered as fixed choices in the Installation form, the
// Information tab, the Installation Checklist and the flat-list filter. Anything
// stored that is NOT in this list came from the "Other" free-text box, so it has
// to be bucketed as Other rather than compared literally — filtering on the
// string 'Other' would hide every site where the installer actually named their
// EMS.
//
// This list lives here, and only here: the Information tab, the Installation
// Checklist and the flat-list filter all render their fixed options by mapping
// over it. Adding an option here is therefore enough — leaving a hardcoded
// MenuItem behind would make both forms show that option as "Other", with the
// specify box pre-filled and the next save able to rewrite it.
export const EMS_KNOWN = ['No', 'Solar Manager', 'Smart Fox', 'Loxone'];

export type EmsBucket = 'notSet' | 'known' | 'other';

// Which of the three groups a stored External EMS value belongs to.
// Whitespace-only counts as unset, matching how the Distribution Partner facet
// decides the same question — otherwise the two filters disagree about what an
// empty field is. Safe to trim here precisely because the forms call this too,
// so form and filter cannot drift apart.
// The comparison against EMS_KNOWN is deliberately exact and case-sensitive: a
// stored 'loxone' then reads as "Other" everywhere rather than in one place only.
export function emsBucket(value: string | null | undefined): EmsBucket {
  const trimmed = (value ?? '').trim();
  if (trimmed === '') return 'notSet';
  return EMS_KNOWN.includes(trimmed) ? 'known' : 'other';
}

// The value a fixed-choice EMS <Select> should display for a stored value:
// '' when unset, the value itself when it is one of the known options, and
// 'Other' for anything typed into the free-text box.
export function emsSelectValue(value: string | null | undefined): string {
  const bucket = emsBucket(value);
  if (bucket === 'notSet') return '';
  return bucket === 'known' ? (value as string).trim() : 'Other';
}
